export const WEBCOIN_SECTIONS = {
  PLAYER_AVATARS: 'playerAvatars',
  AVATAR_FRAMES: 'avatarFrames',
  DAILY_WEBCOIN_OFFERS: 'dailyWebCoinOffers',
  ENERGY_PACKS: 'energyPacks',
};
